import { render } from "./Shipment2SDetail.vue?vue&type=template&id=44dc03c0"
import script from "./Shipment2SDetail.vue?vue&type=script&lang=js"
export * from "./Shipment2SDetail.vue?vue&type=script&lang=js"

import "./Shipment2SDetail.vue?vue&type=style&index=0&id=44dc03c0&scope=true&lang=css"
script.render = render

export default script